module.exports = __webpack_public_path__ + "img/search_white.fda7a514.png";